const COMMON_FETCH_COURSE_TYPES = {
  START: 'START_COMMON_FETCH_COURSE_TYPES',
  COMPLETE: 'COMPLETE_COMMON_FETCH_COURSE_TYPES',
  FAIL: 'FAIL_COMMON_FETCH_COURSE_TYPES',
  CLEANUP: 'CLEANUP_COMMON_FETCH_COURSE_TYPES',
}

export default COMMON_FETCH_COURSE_TYPES
